import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import {EmployeeDetails} from '../employee-details/employee-details.entity';
@Entity('designations')
export class Designations{
  @PrimaryGeneratedColumn("increment",{name:'designation_id'})
  designationId:number;
  @Column("char",{
    nullable:false,
    length:25,
    name:"designation"
    })
  @Index({unique:true})
  designation:string;
 
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
    })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: false,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  @OneToOne(() => EmployeeDetails, employeeDetails => employeeDetails.Id) // specify inverse side as a second parameter
    @JoinColumn()
    employeeDetails: EmployeeDetails;
}